import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  icon,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClasses = 'btn-base focus:ring-2 focus:ring-offset-2 font-medium';

  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-blue-700 focus:ring-primary',
    success: 'bg-success text-white hover:bg-green-700 focus:ring-success',
    danger: 'bg-danger text-white hover:bg-red-700 focus:ring-danger',
    warning: 'bg-warning text-white hover:bg-yellow-700 focus:ring-warning',
    secondary: 'bg-secondary text-white hover:bg-gray-700 focus:ring-secondary',
    outline: 'border border-primary text-primary hover:bg-blue-50 focus:ring-primary',
  };

  const sizeClasses = {
    small: 'px-3 py-1.5 text-sm',
    medium: 'px-4 py-2 text-base',
    large: 'px-6 py-3 text-lg',
  };

  const disabledClasses = disabled || loading ? 'opacity-60 cursor-not-allowed' : '';
  const widthClasses = fullWidth ? 'w-full' : '';

  return (
    <button
      type={type}
      className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${widthClasses} ${className}`}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {loading && (
        <span className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2"></span>
      )}
      {icon && <span className="inline-block mr-2">{icon}</span>}
      <span>{children}</span>
    </button>
  );
};

export default Button;
